"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GlitchBase = _interopRequireDefault(require("../__core__/components/GlitchBase"));

var GLITCH_ID = 'glitch-clip';

var GlitchClip = function GlitchClip(_ref) {
  var children = _ref.children,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 3000 : _ref$duration,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "duration"]);
  return /*#__PURE__*/_react.default.createElement(_GlitchBase.default, (0, _extends2.default)({
    duration: duration,
    glitchId: GLITCH_ID
  }, rest), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children));
};

var _default = /*#__PURE__*/(0, _react.memo)(GlitchClip);

exports.default = _default;
GlitchClip.propTypes = {
  children: _propTypes.default.node.isRequired,
  disabled: _propTypes.default.bool,
  duration: _propTypes.default.number,
  iterationCount: _propTypes.default.string,
  onHover: _propTypes.default.bool,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func
};
